import React from "react";
import { Clock, MapPin, Utensils, Bed, Plane, Compass } from "lucide-react";

const typeIcon = {
  hotel: <Bed className="w-3.5 h-3.5" />,
  food: <Utensils className="w-3.5 h-3.5" />,
  transport: <Plane className="w-3.5 h-3.5 -rotate-45" />,
  attraction: <Compass className="w-3.5 h-3.5" />,
};

export default function DayCard({ day }) {
  return (
    <div className="bg-white rounded-[1.5rem] p-5 md:p-6 shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-[#E8E8ED]" data-testid={`day-${day.day}`}>
      <div className="flex items-baseline gap-3 mb-4">
        <div className="text-xs font-semibold uppercase tracking-[0.15em] text-[#15C3C6]">Hari {day.day}</div>
        <div className="text-lg font-semibold text-[#0A2540]">{day.title}</div>
      </div>
      <ol className="relative border-l border-[#E8E8ED] ml-2 space-y-4">
        {(day.items || []).map((it, i) => (
          <li key={i} className="pl-5 relative">
            <span className={`absolute -left-[7px] top-1 w-3 h-3 rounded-full ring-4 ring-white ${typeColor(it.type)}`} />
            <div className="flex items-start justify-between gap-2 flex-wrap">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <Clock className="w-3 h-3" /> {it.time}
                  {it.duration_min ? <span>· {it.duration_min} min</span> : null}
                </div>
                <div className="text-[15px] font-medium text-[#1D1D1F] mt-0.5 flex items-center gap-1.5">
                  {typeIcon[it.type] || <MapPin className="w-3.5 h-3.5" />}
                  {it.place}
                </div>
                {it.note && <div className="text-sm text-gray-500 mt-0.5">{it.note}</div>}
              </div>
              {it.cost_myr > 0 && (
                <div className="text-sm font-medium text-[#0A2540]">RM{Number(it.cost_myr).toLocaleString()}</div>
              )}
            </div>
            {it.lat && it.lng && (
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://www.google.com/maps/search/?api=1&query=${it.lat},${it.lng}`}
                className="text-[11px] text-[#4FB3E8] hover:underline inline-flex items-center gap-1 mt-1"
              >
                <MapPin className="w-3 h-3" /> Lihat di peta
              </a>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
}

function typeColor(t) {
  switch (t) {
    case "hotel": return "bg-[#0A2540]";
    case "food": return "bg-[#D4AF37]";
    case "transport": return "bg-[#4FB3E8]";
    case "attraction": return "bg-[#15C3C6]";
    default: return "bg-[#E8E8ED]";
  }
}
